// extracted by mini-css-extract-plugin
export var sectionBg = "formSection-module--sectionBg--mEVUx";
export var text = "formSection-module--text--ybR3D";
export var btn = "formSection-module--btn--t9XFR";
export var noteGrid = "formSection-module--noteGrid--xS1H5";